import dashboardTemplate from "./dashboardTemplates/acuadori_dashboard_v3.json";

const dashboardSettings = (name) => {
    const dashboard = JSON.parse(JSON.stringify(dashboardTemplate));
    const dashboardName = name || "Acuadori Dashboard";

    dashboard.title = dashboardName;
    dashboard.name = dashboardName;

    return dashboard;
};

export {
    dashboardSettings
};